module.exports = __webpack_public_path__ + "static/media/enn.1095db4c.mp3";